export const REGIONS = [
    'United States',
    'United Kingdom',
    'Canada',
    'European Union',
    'Australia',
    'Somewhere else'
]

export const HOME_TYPES = [
    'Apartment',
    'Single-level house',
    'House with stairs'
]

export const HOUSEHOLDS = [
    'Just me',
    'Two adults',
    'Family with children',
    'Living with an older relative'
]

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
